import {
	applySsidFilter,
	focusSsid,
	openSsidSection,
} from './adapter';
import {
	openSsidConfigureModal,
	openSsidCreateModal,
	openSsidDeleteModal,
} from './modal';
import {mapSsidPrefill} from './prefill';
import {resolveSsids} from './resolver';
import {
	highlightFirstExistingControl,
} from '../../core/actionHighlighter';

/**
 * Open and optionally filter the SSID inventory.
 * @param {object} command experience command
 * @return {Promise<void>} completion
 */
async function openInventory(command) {
	const sections = {
		global: 'home.global_ssids',
		site: 'site.ssids',
		ap: 'ap.ssids',
	};
	const sectionId = sections[command.params?.context] || sections.global;
	const evidence = await openSsidSection(sectionId);
	const query = command.params?.query;
	if (typeof query === 'string' && query.trim()) {
		await applySsidFilter(query);
	}
	return evidence;
}

const ssidPlugin = {
	id: 'ssid',
	version: 1,
	commandVersion: 1,
	resource: 'ssid',
	operations: [
		'options', 'view', 'search', 'open', 'create', 'configure', 'delete',
		'enable', 'disable', 'bulk_delete',
	],
	dependencies: {
		plugins: ['site', 'access_point', 'canvas.navigation'],
		resolvers: ['site', 'ap', 'aaa_server', 'multi_psk'],
		destinations: ['home.dashboard', 'site.dashboard', 'ap.dashboard'],
	},
	sections: {
		'home.global_ssids': async (command) => {
			const evidence = await openSsidSection('home.global_ssids');
			if (command.params?.action_target === 'bulk_select_delete' &&
				!highlightFirstExistingControl([
					'[role="grid"] [role="checkbox"]',
					'table thead input[type="checkbox"]',
				])) throw new Error('ssid_bulk_selection_unavailable');
			return evidence;
		},
		'site.ssids': async (command) => {
			const evidence = await openSsidSection('site.ssids');
			if (command.params?.action_target === 'bulk_select_delete' &&
				!highlightFirstExistingControl([
					'[role="grid"] [role="checkbox"]',
					'table thead input[type="checkbox"]',
				])) throw new Error('ssid_bulk_selection_unavailable');
			return evidence;
		},
		'ap.ssids': () => openSsidSection('ap.ssids'),
	},
	resolvers: {
		ssid: resolveSsids,
	},
	filters: {
		ssid: (command) => applySsidFilter(command.params?.query),
	},
	focusHandlers: {
		ssid: async (command) => {
			await focusSsid(command.params?.entity_id);
			if (command.params?.action_target === 'status_toggle' &&
				!highlightFirstExistingControl([
					'[role="grid"] [role="switch"]',
					'table tbody [role="switch"]',
					'table tbody input[type="checkbox"]',
				])) throw new Error('ssid_status_toggle_unavailable');
		},
	},
	modals: {
		'ssid.create': openSsidCreateModal,
		'ssid.configure': openSsidConfigureModal,
		'ssid.delete.global': openSsidDeleteModal,
		'ssid.delete.site': openSsidDeleteModal,
	},
	prefillMappers: {
		'ssid.create': mapSsidPrefill,
		'ssid.configure': mapSsidPrefill,
	},
	experiences: {
		'ssid.inventory': openInventory,
	},
};

export default ssidPlugin;
